import "./kit/ui/tokens.css";
import "./kit/ui/app.css";
import { parse, isDoc } from "./engine/router";
import { AUTH_REQUIRED, startAuth } from "./auth/session";

// Sign-in first (shared Keycloak SSO, see auth/session.ts): nobody reaches a page while the gate is on and they are not
// signed in; #/login shows the sign-in page on its own.
const auth = await startAuth();
const wantsLogin = () => location.hash === "#/login";
if ((AUTH_REQUIRED && !auth.authenticated) || (wantsLogin() && !auth.authenticated)) {
  await import("./auth/loginPage").then(m => m.showLogin(auth));
} else {
  if (wantsLogin()) history.replaceState(null, "", "#/");
  // a later jump to #/login (the header's sign-in button) needs the page above, which only runs at start-up
  window.addEventListener("hashchange", () => { if (wantsLogin()) location.reload(); });
  // One tab runs one of two apps: the document pages (business guides, academy, glossary) never download three.js and
  // the 25 scenes, and the 3D app never downloads the academy or the glossary.
  await (isDoc(parse()) ? import("./docs") : import("./app3d")).then(m => m.start());
}
